<template>
  <div class="login">
    <div class="header-warpper">
      <img src="/compass.png" alt="" style="object-fit: contain">
      <span style="font-size: 48px;">Storm Cellar</span>
    </div>
    <a-card title="登录" style="background-color: white">
      <div class="form-wrapper">
        <a-input v-model="form.username" placeholder="邮箱">
          <a-icon slot="prefix" type="user" />
        </a-input>
        <a-input @keydown.enter="handleLogin" type='password' v-model="form.password" placeholder="密码">
          <a-icon slot="prefix" type="lock" />
        </a-input>
        <a-alert message="新邮箱将自动注册为新用户" show-icon></a-alert>
        <a-button :loading='requesting' @click="handleLogin" type='primary' style="width: 100%">{{ requesting ? '登录中' : '登录' }}</a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import { login } from '@/api/user.js'
import { mapMutations } from 'vuex'
import { message } from 'ant-design-vue'
export default {
  data() {
    return {
      requesting: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapMutations('UserModule', ['SET_USERINFO']),
    async handleLogin() {
      this.requesting = true
      const { username, password } = this.form
      try {
        const resp = await login(username, password)
        this.SET_USERINFO(resp)
        localStorage.setItem('token', resp.access_token)
        this.$router.push('/')
        if (resp.isNew) message.success('新用户创建成功')
        message.success('登录成功')
      } catch (e) {
        message.error(e.response.data.message)
      } finally {
        this.requesting = false
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.header-warpper {
  display: flex;
  & > * + * {
    margin-left: 20px;
  }
  margin-bottom: 20px;
}
.login {
  background-color: #eef0f3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url(https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg);
}
.form-wrapper {
  & > * + * {
    margin-top: 25px;
  }
}
</style>